import React, { useCallback } from 'react';
import {useDropzone} from 'react-dropzone';
import { AiOutlineUpload } from "react-icons/ai";
import { IoMdClose } from 'react-icons/io';

function CreatorDashboardReaction(props) {
  const onDrop = useCallback(async (acceptedFiles) => {
    let fileArray = [];
    acceptedFiles.map(function(file) {
      if((file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg") && fileArray.length === 0) {
        fileArray.push(file);
      }
      return(
        file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg"
          ?
        <img key={file.path} src={URL.createObjectURL(file)} className="w-10 h-10" />
          :
        null
      );
    }).filter(x => x).slice(0, 1);

    if(fileArray.length > 0) {
      await props.addOrReplaceEmote(fileArray[0], props.index);
    }
  }, []);
  const {getRootProps, getInputProps} = useDropzone({
    onDrop
  });

  return (
    props.emotes.length > props.index
      ?
    <div {...getRootProps({className: 'dropzone'})}>
      <input {...getInputProps()} />
      <IoMdClose onClick={(e) => {
        e.stopPropagation();
        props.removeEmote(props.index);
      }}
        className="flex text-xs ml-12 mt-4 md:text-xs lg:text-base font-medium text-zinc-400 cursor-pointer dark:text-gray-600"
        size={24}
      />
      <img
        className="w-16 h-16 sm:w-20 sm:h-20 text-2xl text-zinc-400 flex items-center justify-center rounded-md bg-zinc-700 cursor-pointer"
        src={props.emotes[props.index][0]}
      />
    </div>
      :
    props.emotes.length === props.index
      ?
    <div {...getRootProps({className: 'dropzone'})}>
      <input {...getInputProps()} />
      <div className="w-16 h-16 sm:w-20 sm:h-20 text-2xl text-zinc-400 flex items-center justify-center rounded-md bg-zinc-700 cursor-pointer">
        <AiOutlineUpload />
      </div>
    </div>
      :
    <div className="w-16 h-16 sm:w-20 sm:h-20 text-2xl text-zinc-400 flex items-center justify-center rounded-md bg-zinc-700 cursor-pointer">
      <AiOutlineUpload />
    </div>
  );
}

export default CreatorDashboardReaction;